import * as React from 'react';
import { useSelector } from 'react-redux';

import { SalesStartInfo } from '../../components/SalesStartInfo';
import { getSalesStartHousesString } from '../../selectors/newbuilding';

export function SalesStartInfoContainer() {
  const salesStartHousesString = useSelector(getSalesStartHousesString);

  if (!salesStartHousesString) {
    return null;
  }

  return <SalesStartInfo content={salesStartHousesString} />;
}
